'use strict';

/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/call-bind-apply-helpers/functionApply.js
// module id = ../../../../call-bind-apply-helpers/functionApply.js
// module chunks = 5